module.exports = __webpack_public_path__ + "img/EASTASIA_VEGETABLES.222f4bd5.png";